module.exports = __webpack_public_path__ + "img/Tokyo-cover.36ebd79b.jpg";